// UserProfilePost.js
import { connect } from 'react-redux';
import { goBack } from 'redux-first-history';

import ProfilePost from '../component/ProfilePost.jsx';

import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getFeedName from '../selector/getFeedName.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import getProfileFeedUnixTimestamp from '../selector/getProfileFeedUnixTimestamp.js';
import getUserData from '../selector/getUserData.js';

import setMessageHeightInFeed from '../action/setMessageHeightInFeed.js';
import fetchFeeds, { getReturnType } from '../action/fetchFeeds.js';
import setSelectedFeedQueryDraftOption from '../action/setSelectedFeedQueryDraftOption.js';
import setSelectedFeedQueryOption from '../action/setSelectedFeedQueryOption.js';

import {
  PROFILE_FEED_REMOTE_CONFIG_KEY_MAP,
  PROFILE_DRAFT_FEED_REMOTE_CONFIG_KEY_MAP,
  ProfileListPublishStatus,
} from '../resource/profileConstants.js';
import { QueryPrefix, QueryType } from '../resource/feedConstants.js';
import { USER_PROFILE_STORY_LAYOUT } from '../RemoteConfigKeys.js';

const mapStateToProps = (state, { userId, listType, publishStatus }) => {
  const remoteConfigKeyMap =
    ProfileListPublishStatus.DRAFT === publishStatus
      ? PROFILE_DRAFT_FEED_REMOTE_CONFIG_KEY_MAP
      : PROFILE_FEED_REMOTE_CONFIG_KEY_MAP;
  const feedNameRemoteConfigKey = remoteConfigKeyMap[listType];
  const outboxFeedName = getFeedName(
    state,
    feedNameRemoteConfigKey,
    '{USER_ID}',
    userId
  );
  const sortingsRemoteConfigKey = `${feedNameRemoteConfigKey}_${
    QueryPrefix[QueryType.SORT]
  }`;
  const filtersRemoteConfigKey = `${feedNameRemoteConfigKey}_${
    QueryPrefix[QueryType.FILTER]
  }`;
  const { feedNameWithQuery } = getSelectedQueryOptionObject(
    state,
    outboxFeedName,
    getSelectedFeedQueryOptions(state, feedNameRemoteConfigKey, undefined),
    getRemoteConfigData(state, sortingsRemoteConfigKey)?.[0]
  );
  const listSelectPath = [
    'home',
    getReturnType({ feedName: feedNameWithQuery }),
    feedNameWithQuery,
  ];
  const meId = getMeData(state, 'id');
  const nextPage = getListData(state, listSelectPath, 'nextPage');
  const pinnedItemIds = getListData(
    state,
    [...listSelectPath, 'pinned'],
    'itemIds'
  );
  const postIds = getListData(state, listSelectPath, 'itemIds');
  const isFirstPageFetched = getNetworkingData(
    state,
    [...listSelectPath, 1],
    'isFetched'
  );
  const isFirstPageFetching = getNetworkingData(
    state,
    [...listSelectPath, 1],
    'isFetching'
  );
  const isNextPageFetching = getNetworkingData(
    state,
    [...listSelectPath, nextPage],
    'isFetching'
  );
  const userProfileStoryLayout = getRemoteConfigData(
    state,
    USER_PROFILE_STORY_LAYOUT
  );
  return {
    meId,
    outboxFeedName,
    feedNameWithQuery,
    feedNameRemoteConfigKey,
    nextPage,
    profileFeedUnixTimestamp: getProfileFeedUnixTimestamp(
      state,
      userId,
      listType
    ),
    isFirstPageFetched,
    isFirstPageFetching,
    isNextPageFetching,
    pinnedItemIds,
    postIds,
    userProfileStoryLayout,
    filters: getRemoteConfigData(state, filtersRemoteConfigKey),
    selectedFilters: getSelectedFeedQueryOptions(
      state,
      feedNameRemoteConfigKey,
      QueryType.FILTER
    ),
    username: getUserData(state, userId, 'username'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: () => dispatch(goBack()),
    fetchFeeds: payload => dispatch(fetchFeeds(payload)),
    setMessageHeightInFeed: ({ feedName, messageObject }) =>
      dispatch(
        setMessageHeightInFeed({
          feedName,
          messageObject,
        })
      ),
    setSelectedFeedQueryDraftOption: data =>
      dispatch(setSelectedFeedQueryDraftOption(data)),
    setSelectedFeedQueryOption: data =>
      dispatch(setSelectedFeedQueryOption(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProfilePost);
